export const validateEmail = (email: string): boolean => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/
        ) !== null;
};

export const validatePassword = (password: string): boolean => {
    return String(password)
        .match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[!#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]).{8,}$/) !== null;
};

export const validateOnlyNumbers = (value: string): boolean => {
    return String(value).match(/^\d*$/) !== null
}

export const validateIsHttp = (value: string): boolean => {
    return String(value).match(/^https?:\/\//) !== null
}

export const validateQtyInput = (value: string): boolean => {
    return /^([1-9][0-9]*)$/.test(value);
}
